import { render, staticRenderFns } from "./Lingallery.vue?vue&type=template&id=40681078&scoped=true&"
import script from "./Lingallery.vue?vue&type=script&lang=js&"
export * from "./Lingallery.vue?vue&type=script&lang=js&"
import style0 from "./Lingallery.vue?vue&type=style&index=0&id=40681078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40681078",
  null
  
)

export default component.exports